import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import HowPixanoWorksSection from '../components/HowPixanoWorksSection';
import WhyPixanoSection from '../components/WhyPixanoSection';
import RealWorldDataSection from '../components/RealWorldDataSection';
import AppDownloadStrip from '../components/AppDownloadStrip';
import HomepageClosingCTASection from '../components/HomepageClosingCTASection';
import Footer from '../components/Footer';

const Homepage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = 'Pixano — Real-World AI Training Data';
  }, []);

  useEffect(() => {
    if (location.pathname !== '/' || location.hash !== '#training-data') return;

    const scrollToSection = () => {
      document.getElementById('training-data')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const id = window.requestAnimationFrame(() => {
      window.requestAnimationFrame(scrollToSection);
    });

    return () => window.cancelAnimationFrame(id);
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen bg-[#0B0F14]">
      <Navigation />
      <main>
        <HeroSection />
        <HowPixanoWorksSection />
        <WhyPixanoSection />
        <RealWorldDataSection />
      </main>
      <HomepageClosingCTASection />
      <AppDownloadStrip />
      <Footer />
    </div>
  );
};

export default Homepage;
